// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const id: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Cara Bermain',
  'howto.pieces.heading': 'Bagian-bagian',
  'howto.pieces.source': 'Sumber',
  'howto.pieces.mirror': 'Cermin',
  'howto.pieces.switch': 'Sakelar',
  'howto.pieces.exit': 'Pintu keluar',
  'howto.pieces.wall': 'Dinding',
  'howto.controls.heading': 'Kontrol',
  'howto.controls.clickSlot.line1': 'Klik slot',
  'howto.controls.clickSlot.line2': 'taruh cermin',
  'howto.controls.dragMirror.line1': 'Seret cermin',
  'howto.controls.dragMirror.line2': 'putar',
  'howto.controls.rightClick.line1': 'Klik kanan',
  'howto.controls.rightClick.line2': 'lepas cermin',
  'howto.controls.hint': 'Roda mouse: putar halus 1°.   Ketuk cermin: putar 15°.',
  'howto.objective.line1': 'Nyalakan setiap sakelar — kunci pintu keluar terbuka sendiri.',
  'howto.objective.line2': 'Lalu klik pintu keluar. Selesaikan dengan cermin sesedikit mungkin.',

  'howtoColor.title': 'Warna & Prisma',
  'howtoColor.pieces.heading': 'Bagian baru',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Sakelar merah',
  'howtoColor.pieces.yellowSwitch': 'Sakelar kuning',
  'howtoColor.pieces.whiteSwitch': 'Sakelar putih',
  'howtoColor.how.heading': 'Cara kerjanya',
  'howtoColor.how.line1': 'Berkas putih membawa cahaya merah, hijau, dan biru sekaligus.',
  'howtoColor.how.line2': 'Prisma membelah cahaya putih menjadi tiga berkas warna di tiga sisinya.',
  'howtoColor.how.line3': 'Klik prisma yang sudah dipasang untuk memutar sisi masuknya.',
  'howtoColor.switches.line1': 'Sakelar menampilkan titik warna — itulah warna yang diinginkannya.',
  'howtoColor.switches.line2': 'Sakelar kuning (titik merah + hijau) butuh kedua warna bersama.',
  'howtoColor.switches.line3':
    'Sakelar putih (ketiga warna) butuh merah, hijau, DAN biru bersamaan.',

  'options.hints.label': 'Tampilkan sudut petunjuk di teka-teki',
  'options.hints.help':
    'Menampilkan sudut antara berkas datang dan berkas pantul di setiap pantulan.',

  'level.01-intro.title': 'Halo Cahaya',
  'level.02-two-mirrors.title': 'Dua Belokan',
  'level.03-corner.title': 'Dinding Menghalangi',
  'level.04-two-targets.title': 'Dua Target',
  'level.05-tight.title': 'Sempit',
  'level.06-hello-color.title': 'Halo Warna',
  'level.07-pick-a-side.title': 'Pilih Satu Sisi',
  'level.08-yellow.title': 'Kuning',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spektrum',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'siku',
  'puzzle.hint.angleType.acute': 'lancip',
  'puzzle.hint.angleType.obtuse': 'tumpul',
  'puzzle.hint.label': '{angle}°\n{type}',
};
